import { Box } from '@mui/material';
import { Choice } from 'types/vehicles/types';
import {
  VEHICLE_STATUS_COLOR_MAP,
  VEHICLE_STATUS_COMPLETION_PERCENTAGE_MAP,
  VEHICLE_STATUS_LABEL_MAP,
} from '../config';
import { vehicleStatusStyles } from '../list/styles';

const VehicleStatus = (status: Choice) => {
  const { value } = status;
  const name = VEHICLE_STATUS_LABEL_MAP[value];
  const color = VEHICLE_STATUS_COLOR_MAP[value];
  const progressPercentage = VEHICLE_STATUS_COMPLETION_PERCENTAGE_MAP[value];
  return (
    <Box sx={vehicleStatusStyles.container}>
      <Box sx={{ ...vehicleStatusStyles.name, color }}>{name}</Box>
      <Box sx={{ ...vehicleStatusStyles.progressBarOuter }}>
        <Box sx={{ ...vehicleStatusStyles.progressBarInner, width: progressPercentage, backgroundColor: color }}></Box>
      </Box>
    </Box>
  );
};

export default VehicleStatus;
